import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Fuel, 
  Settings,
  ClipboardList,
  Settings2,
  Sun,
  X
} from 'lucide-react';
import clsx from 'clsx';

const navItems = [
  { name: 'Dashboard', icon: LayoutDashboard, path: '/' },
  { name: 'Start of Day', icon: Sun, path: '/morning-readings' },
  { name: 'Daily Accounting', icon: ClipboardList, path: '/accounting' },
  { name: 'Reports', icon: ClipboardList, path: '/reports' },
  { name: 'Employees', icon: Users, path: '/employees' },
  { name: 'Fuel Rates', icon: Fuel, path: '/rates' },
  { name: 'Pump Config', icon: Settings2, path: '/pump-config' },
  { name: 'Settings', icon: Settings, path: '/settings' },
];

const Sidebar = ({ isOpen, setIsOpen }) => {
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-slate-900/50 z-20 md:hidden" 
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Sidebar container */}
      <aside className={clsx(
        'fixed md:static inset-y-0 left-0 z-30 w-64 bg-white border-r border-slate-200 transform transition-transform duration-300 ease-in-out flex flex-col',
        isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
      )}>
        <div className="h-16 flex items-center justify-between px-6 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center">
              <Fuel className="text-white w-5 h-5" />
            </div>
            <span className="text-lg font-bold text-slate-900 tracking-tight">PumpPro</span>
          </div>
          <button 
            onClick={() => setIsOpen(false)}
            className="md:hidden text-slate-500 hover:text-slate-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              className={({ isActive }) => clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 group font-medium text-sm',
                isActive 
                  ? 'bg-primary-50 text-primary-600' 
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              )}
            >
              <item.icon className={clsx(
                'w-5 h-5 transition-colors',
                'group-hover:text-primary-600'
              )} />
              {item.name}
            </NavLink>
          ))}
        </nav>
        
        <div className="p-4 border-t border-slate-200">
          <div className="bg-slate-50 p-4 rounded-xl">
            <p className="text-xs text-slate-500 font-medium mb-1">Current Shift</p>
            <p className="text-sm font-semibold text-slate-900">Morning Shift</p>
            <p className="text-xs text-slate-500 mt-1">03 June 2026</p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
